import { render, staticRenderFns } from "./exhibitBox.vue?vue&type=template&id=769e0d63&scoped=true"
import script from "./exhibitBox.vue?vue&type=script&lang=js"
export * from "./exhibitBox.vue?vue&type=script&lang=js"
import style0 from "./exhibitBox.vue?vue&type=style&index=0&id=769e0d63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e0d63",
  null
  
)

export default component.exports